import memoize from 'memoize-one';

export const getAllowedDashboards = memoize((dashboards, user) => {
    if (!dashboards || !user || !user.permissions) return [];
    return dashboards.filter(d => 
      user.role === 'owner' ||
      user.permissions.manageDashboards ||
      user.permissions.manageDashboardsViewOnly ||
      (user.permissions.dashboards && user.permissions.dashboards.some(p => 
        p.dashboardId === d._id.toString() && (p.view || p.edit)
      ))
    );
  });